import React, { useEffect, useState, useRef } from 'react';
import { Star, Quote, ChevronLeft, ChevronRight, CheckCircle } from 'lucide-react';
const testimonials = [{
  name: 'Sarah Johnson',
  role: 'E-commerce Manager',
  company: 'Fashion Boutique',
  image: 'https://randomuser.me/api/portraits/women/12.jpg',
  content: "Since implementing CommerceBoost, our store's conversion rate has increased by 28%. The floating cart and wishlist features have been game-changers for our customers.",
  rating: 5,
  date: 'November 2024',
  verified: true
}, {
  name: 'Michael Chen',
  role: 'Store Owner',
  company: 'Tech Gadgets',
  image: 'https://randomuser.me/api/portraits/men/32.jpg',
  content: 'The store-wide sale module helped us run our most successful Black Friday promotion ever. Setup was incredibly easy and the results were immediate.',
  rating: 5,
  date: 'October 2024',
  verified: true
}, {
  name: 'Emma Rodriguez',
  role: 'Digital Marketer',
  company: 'Home Goods',
  image: 'https://randomuser.me/api/portraits/women/45.jpg',
  content: "I've tried several WooCommerce plugins, but CommerceBoost offers the best value. All the modules work seamlessly together, and the support team is incredibly responsive.",
  rating: 5,
  date: 'December 2024',
  verified: true
}, {
  name: 'James Wilson',
  role: 'WordPress Developer',
  company: 'Agency Partners',
  image: 'https://randomuser.me/api/portraits/men/67.jpg',
  content: "As an agency, we've implemented CommerceBoost on multiple client sites with consistently positive results. The code is clean and it integrates perfectly with other plugins.",
  rating: 5,
  date: 'September 2024',
  verified: true
}, {
  name: 'Lisa Thompson',
  role: 'Marketing Director',
  company: 'Beauty Store',
  image: 'https://randomuser.me/api/portraits/women/68.jpg',
  content: 'The multi-item discount feature increased our average order value by 45%. Customers love the tiered pricing, and it was so simple to set up.',
  rating: 5,
  date: 'November 2024',
  verified: true
}, {
  name: 'David Park',
  role: 'Online Retailer',
  company: 'Sports Equipment',
  image: 'https://randomuser.me/api/portraits/men/22.jpg',
  content: 'The Ajax search is lightning fast and our customers can find products instantly. This alone has improved our user experience dramatically.',
  rating: 5,
  date: 'October 2024',
  verified: true
}, {
  name: 'Rachel Green',
  role: 'Store Manager',
  company: 'Jewelry Boutique',
  image: 'https://randomuser.me/api/portraits/women/33.jpg',
  content: 'The wishlist feature has been incredible for our high-ticket items. Customers save products and we can send targeted reminders. Our return rate increased by 31%.',
  rating: 5,
  date: 'December 2024',
  verified: true
}, {
  name: 'Tom Anderson',
  role: 'E-commerce Consultant',
  company: 'Retail Solutions',
  image: 'https://randomuser.me/api/portraits/men/54.jpg',
  content: 'I recommend CommerceBoost to all my clients. The ROI is immediate and the features are exactly what modern WooCommerce stores need.',
  rating: 5,
  date: 'November 2024',
  verified: true
}, {
  name: 'Nina Patel',
  role: 'Business Owner',
  company: 'Organic Foods',
  image: 'https://randomuser.me/api/portraits/women/89.jpg',
  content: 'The recently viewed products feature keeps customers engaged longer. Our bounce rate dropped significantly after implementing this.',
  rating: 5,
  date: 'September 2024',
  verified: true
}, {
  name: 'Marcus Johnson',
  role: 'Digital Strategy Lead',
  company: 'Fashion Forward',
  image: 'https://randomuser.me/api/portraits/men/41.jpg',
  content: 'CommerceBoost delivered results from day one. The floating cart reduced our cart abandonment by 28%. Best investment we made this year.',
  rating: 5,
  date: 'October 2024',
  verified: true
}, {
  name: 'Sophie Laurent',
  role: 'Store Owner',
  company: 'Artisan Crafts',
  image: 'https://randomuser.me/api/portraits/women/71.jpg',
  content: 'The countdown timer on our sale campaigns creates real urgency. We saw a 35% spike in conversions during our last promotion.',
  rating: 5,
  date: 'December 2024',
  verified: true
}, {
  name: 'Alex Rivera',
  role: 'Growth Manager',
  company: 'Tech Accessories',
  image: 'https://randomuser.me/api/portraits/men/78.jpg',
  content: 'Every module is thoughtfully designed and works flawlessly. The support team is amazing too - they helped us customize everything perfectly.',
  rating: 5,
  date: 'November 2024',
  verified: true
}];
export function Testimonials() {
  const testimonialsRef = useRef(null);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (testimonialsRef.current) {
      observer.observe(testimonialsRef.current);
    }
    return () => {
      if (testimonialsRef.current) {
        observer.disconnect();
      }
    };
  }, []);
  const updateScrollButtons = () => {
    if (scrollContainerRef.current) {
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = scrollContainerRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener('scroll', updateScrollButtons);
      updateScrollButtons();
      return () => container.removeEventListener('scroll', updateScrollButtons);
    }
  }, []);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const cardWidth = 320;
      const gap = 32;
      const scrollAmount = cardWidth + gap;
      const newScrollLeft = direction === 'left' ? scrollContainerRef.current.scrollLeft - scrollAmount : scrollContainerRef.current.scrollLeft + scrollAmount;
      scrollContainerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-20 md:py-32 bg-gradient-to-b from-white to-gray-50 overflow-hidden" ref={testimonialsRef} data-id="element-321">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-322">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-323">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 tracking-tight" data-id="element-324">
            Loved by{' '}
            <span className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent" data-id="element-325">
              store owners
            </span>
          </h2>
          <p className="text-xl text-gray-600" data-id="element-326">
            Join hundreds of successful WooCommerce stores boosting their
            conversions with CommerceBoost.
          </p>
        </div>
        <div className="relative" data-id="element-327">
          {/* Navigation buttons */}
          <button onClick={() => scroll('left')} disabled={!canScrollLeft} className={`absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full p-3 shadow-lg transition-all ${canScrollLeft ? 'opacity-100 hover:scale-110' : 'opacity-0 pointer-events-none'}`} aria-label="Previous testimonials" data-id="element-328">
            <ChevronLeft className="h-6 w-6 text-gray-600" data-id="element-329" />
          </button>
          <button onClick={() => scroll('right')} disabled={!canScrollRight} className={`absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full p-3 shadow-lg transition-all ${canScrollRight ? 'opacity-100 hover:scale-110' : 'opacity-0 pointer-events-none'}`} aria-label="Next testimonials" data-id="element-330">
            <ChevronRight className="h-6 w-6 text-gray-600" data-id="element-331" />
          </button>
          {/* Carousel container */}
          <div ref={scrollContainerRef} className="flex gap-8 overflow-x-auto scrollbar-hide snap-x snap-mandatory px-12" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-332">
            {testimonials.map((testimonial, index) => <div key={index} className={`flex-shrink-0 w-80 bg-white rounded-2xl p-8 transition-all duration-700 transform border border-gray-200 hover:border-gray-300 hover:shadow-xl snap-start ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} style={{
            transitionDelay: `${Math.min(index * 100, 800)}ms`
          }} data-id="element-333">
                <Quote className="h-8 w-8 text-purple-600 mb-4" data-id="element-334" />
                <div className="flex items-center justify-between mb-4" data-id="element-335">
                  <div className="flex items-center" data-id="element-336">
                    {[...Array(5)].map((_, i) => <Star key={i} className={`h-5 w-5 ${i < testimonial.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} data-id="element-337" />)}
                  </div>
                  {testimonial.verified && <div className="flex items-center gap-1 text-green-600" data-id="element-338">
                      <CheckCircle className="h-4 w-4" data-id="element-339" />
                      <span className="text-xs font-medium" data-id="element-340">Verified</span>
                    </div>}
                </div>
                <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-341">
                  {testimonial.content}
                </p>
                <div className="flex items-center justify-between pt-6 border-t border-gray-100" data-id="element-342">
                  <div className="flex items-center" data-id="element-343">
                    <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full mr-4 object-cover" data-id="element-344" />
                    <div data-id="element-345">
                      <h4 className="font-bold text-gray-900" data-id="element-346">
                        {testimonial.name}
                      </h4>
                      <p className="text-sm text-gray-500" data-id="element-347">
                        {testimonial.role}
                      </p>
                    </div>
                  </div>
                </div>
                <p className="text-xs text-gray-400 mt-3" data-id="element-348">{testimonial.date}</p>
              </div>)}
          </div>
        </div>
        <div className="mt-20 text-center" data-id="element-349">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-100 to-blue-100 border border-purple-200 rounded-full px-6 py-3" data-id="element-350">
            <Star className="h-5 w-5 text-purple-600 fill-current" data-id="element-351" />
            <span className="font-medium text-gray-900" data-id="element-352">
              4.8/5 rating from 500+ store owners
            </span>
          </div>
        </div>
      </div>
    </section>;
}